var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { color } from 'styled-system';
import { linearGradient } from 'polished';
import { Flex } from '../Flex';
import { getForwardPropOpts } from '../../theme/helper';
import { boxSizing } from '../../theme/system-utilities';
export var GradientBlockType;
(function (GradientBlockType) {
    GradientBlockType["Horizontal"] = "to right";
    GradientBlockType["Vertical"] = "to bottom";
})(GradientBlockType || (GradientBlockType = {}));
export var GradientBlock = styled(Flex, getForwardPropOpts(['color', 'type']))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  ", "\n"], ["\n  ", ";\n  ", ";\n\n  ",
    "\n"])), boxSizing, color, function (_a) {
    var startColor = _a.startColor, endColor = _a.endColor, type = _a.type;
    return startColor &&
        (endColor
            ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ",
                "\n        "])), linearGradient({
                colorStops: [startColor, endColor],
                toDirection: type,
            })) : "background-color: " + startColor + ";");
});
GradientBlock.defaultProps = {
    type: GradientBlockType.Horizontal,
    boxSizing: 'border-box',
    width: '100%',
    bg: 'gray.2',
};
var templateObject_1, templateObject_2;
